import React, { Component } from "react";
import { Layout, Dropdown, Space, Avatar, } from "antd";
import { app, oss, context, router, system, Modal } from "@/nano";
import { position } from "@/nano/redux/reducers";
import { APP_UPDATE_TIME } from "@/constants/config";
import { DownOutlined, UserSwitchOutlined, LoginOutlined, CheckOutlined, } from "@ant-design/icons";

import "./index.less";

import PersonalSetting from "./personalSetting";

export default class Navbar extends Component {

  state = {
    release: {},
    personalSettingModal: {
      open: false,
    }
  };

  getItems = () => {
    const items = [
      {
        key: "setting",
        label: "个人设置",
        // icon: <SettingOutlined />,
      },
      { type: "divider", },
    ];
    // 切换岗位
    const { positionList } = position.state;
    if (positionList.length) {
      const position = context.getPosition();
      items.push({
        key: "switchPosition",
        label: "切换岗位",
        icon: <UserSwitchOutlined />,
        children: positionList.map(item => {
          return {
            key: item.id,
            label: item.name,
            icon: item.id === position.id ? <CheckOutlined /> : undefined,
          };
        }),
      });
    }
    // 退出登录
    items.push({
      key: "loginOut",
      label: "退出登录",
      icon: <LoginOutlined />,
    });
    return items;
  };

  onMenuClick = (e) => {
    const lastKey = e.keyPath[e.keyPath.length - 1];
    switch (lastKey) {
      case "switchPosition":
        return this.onSwitchPositionClick(e);
      case "setting":
        return this.onSettingClick(e);
      case "loginOut":
        return this.onLogoutClick(e);
      default:
        console.log("onMenuClick ", e);
        break
    }
  };

  onSwitchPositionClick = (e) => {
    const { key, } = e;
    const param = { positionId: key, };
    app.switchPosition(param).then(() => {
      window.location.pathname = system.getSystemReleasePath("/");
    });
  };

  onSettingClick = (e) => {
    // console.log("onSettingClick ", e);
    this.setState({
      ...this.state,
      personalSettingModal: {
        open: true,
        title: "个人设置",
        type: "update",
        //data: e,
      }
    });
  };

  onLogoutClick = (e) => {
    app.logout().then(_ => {
      router.history.push("/login");
    });
  };

  onPersonalSettingCancel = () => {
    this.setState({
      ...this.state,
      personalSettingModal: {
        ...this.state.personalSettingModal,
        open: false,
      }
    });
  };

  render() {
    const userInfo = context.getUser();
    const release = system.getSystemRelease();
    const indexEnableFunArr = (release.indexEnableFun || "").split(",");
    const { personalSettingModal } = this.state;
    return (
      <Layout.Header
        className={"nano-navbar " + (this.props.className || "")}
        style={{
          padding: 0,
        }}
      >
        <div className="nano-navbar-box">
          <div className="nano-navbar-left">
            <div className="logo">
              {release.indexLogo && <img src={oss.getUrl(release.indexLogo)} alt="logo" />}
            </div>
          </div>
          <div className="nano-navbar-right">
            <Space>
              {indexEnableFunArr.includes("5") && (
                <div className="update-time">
                  <span>更新时间：{APP_UPDATE_TIME}</span>
                </div>
              )}
              <Dropdown
                className="account"
                menu={{
                  items: this.getItems(),
                  onClick: this.onMenuClick,
                }}
              >
                <div>
                  {userInfo.avatar && <Avatar src={oss.getUrl(userInfo.avatar)} />}
                  <span className="name">{userInfo.name}</span>
                  <DownOutlined />
                </div>
              </Dropdown>
            </Space>
          </div>
        </div>

        {personalSettingModal.open && (
          <Modal
            title="个人设置"
            width={1000}
            onCancel={this.onPersonalSettingCancel}
          // bodyStyle={{
          //   height: 600,
          // }}
          >
            {/* <PersonalSetting {...personalSettingModal} onCancel={this.onPersonalSettingCancel} onAfterSubmit={this.getList} /> */}
            <PersonalSetting {...personalSettingModal} onCancel={this.onPersonalSettingCancel} />
          </Modal>
        )}
      </Layout.Header>
    );
  };
};
